import React, { useEffect } from 'react';
import { Heading, Text } from '@chakra-ui/react';

import BasicPage from "./BasicPage";
import SupportArea from "./static/SupportArea";

type PropTypes = {
  onMount?: () => void;
};

const RegistrationSuccess = ({ onMount }: PropTypes) => {
  useEffect(() => { onMount && onMount(); }, [onMount]);

  return (
    <BasicPage type="modal">
      <Heading>You're in!</Heading>
      <Text>
        Account creation was successful! Check your email for next steps, including how to confirm
        attendance for your first class and verify your email.
      </Text>
      <SupportArea />
    </BasicPage>
  );
};

export default RegistrationSuccess;
